import "./RequestTax.css";
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import Heading from "../../../componentes/fluxo-engenheiro/heading/heading";
import BallsColor from "../../../componentes/fluxo-engenheiro/ballsColor/ballsColor";
import { Tooltip } from "@mui/material";
import { GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import GenericGrid from "../../../componentes/fluxo-engenheiro/grid/grid";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getClassificationsMessage,
  getClassificationsTax,
  getClassificationsId,
  classificationsAprroverTax,
  getSessionReset,
  getSessionResetVerifyPn,
} from "../../../redux/actions/fluxoNSimilar";
import asc from "../../../assets/svgs/asc.svg";
import desc from "../../../assets/svgs/desc.svg";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import EyesButtonIcon from "../../../assets/svgs/eyesButtonIcon.svg";
import ModalAprover from "../modalAprover/modalAprover";
import Notification from "../../fluxo-tax/Notification/notification";
import functionDate from "../../../utils/formatarData";
import Textnotifications from "../../../utils/notifications";
import { useRoles } from "../../../hooks/roles";
import ModalLog from "../../../componentes/fluxo-engenheiro/modalLog/modalLog";
import iconabort from "../../../assets/svgs/abort.svg";
import SucessIcon from "../../../assets/svgs/sucess.svg";
import usePersistedStateOnDemand from "../../../hooks/usePersistedStateOnDemand";
import { getTaxColumns } from "../../../utils/DataGrid/columnsTax";
import { SkeletonWrapper } from "../../SkeletonWrapper/sleketonWrapper";
import { CorrigirModal } from "../../corrigirModal/corrigirModal";
import { ReactComponent as IconDownload } from "../../../assets/svgs/downloadBlue.svg";
import { useReportDownload } from "../../../hooks/useReportDownload";
import { showNotificationUtil } from "../../../utils/showNotificationUtil";
import { resolveSortByField } from "../../../utils/sortFieldMapper";
import { getTaxFiltersFromStorage } from "../../../utils/taxFilters";
import { resolveNcmErrorMessage } from "../../../utils/ncmErrorMessages";
import Modal from "../../modal/modal";
import { usePersistedPagination } from "../../../hooks/usePersistedPagination";

const HOME_NOTIFICATION_KEY = "homeNotification";

type ClassificationPart = {
  classificationId: string;
  sessionId: string;
  status: string;
  productId: string;
  partNumber: string;
  description: string;
  emitter: string;
  centerFilter: string;
  center: string;
  createAt: string;
  ncmCode: string;
};

export const RequestTax = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState<number | undefined>(undefined);
  const [modalApprover, setModalApprover] = useState(false);
  const [modalCorrigir, setModalCorrigir] = useState(false);
  const [modalReset, setModalReset] = useState(false);
  const [backgroudError, setBackgroudError] = useState("");
  const [description, setDescription] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [labelNotification, SetLabelNotification] = useState("");
  const [classificationId] = useState<ClassificationPart | null>(null);
  const { page, setPage, pageSize, setPageSize, sortModel, setSortModel } =
    usePersistedPagination("pagination_request_tax", { page: 1, pageSize: 5 });
  const [corrigirText, setCorrigirText] = useState("");
  const [ncmCode, setNcmCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(false);

  // MATERIAL PART NUMBER
  const [materialPartNumber, setMaterialPartNumber, persistMaterialPartNumber] =
    usePersistedStateOnDemand<string>("materialPartNumber", "");

  // MATERIAL PART DESC
  const [materialPartDesc, setMaterialPartDesc, persistMaterialPartDesc] =
    usePersistedStateOnDemand<string>("materialPartDesc", "");

  // CENTER FILTER
  const [centerFilter, setCenterFilter, persistCenterFilter] =
    usePersistedStateOnDemand<string>("centerFilter", "");

  // EMITENTE
  const [emitentePartNumber, setEmitentePartNumber, persistEmitentePartNumber] =
    usePersistedStateOnDemand<string>("emitentePartNumber", "");

  // START DATE
  const [startDate, setStartDate, persistStartDate] =
    usePersistedStateOnDemand<string>("startDate", "");

  // END DATE
  const [endDate, setEndDate, persistEndDate] =
    usePersistedStateOnDemand<string>("endDate", "");

  const [
    classificationQuizStartDate,
    setClassificationQuizStartDate,
    persistClassificationQuizStartDate,
  ] = usePersistedStateOnDemand<string>("classificationQuizStartDate", "");

  const [
    classificationQuizFinishDate,
    setClassificationQuizFinishDate,
    persistClassificationQuizFinishDate,
  ] = usePersistedStateOnDemand<string>("classificationQuizFinishDate", "");

  const [
    classificationApprovalStartDate,
    setClassificationApprovalStartDate,
    persistClassificationApprovalStartDate,
  ] = usePersistedStateOnDemand<string>(
    "classificationApprovalStartDate",
    "",
  );

  const [
    classificationApprovalEndDate,
    setClassificationApprovalEndDate,
    persistClassificationApprovalEndDate,
  ] = usePersistedStateOnDemand<string>("classificationApprovalEndDate", "");

  // FLAG
  const [selectedOptionsFlag, setSelectedOptionsFlag, persistFlag] =
    usePersistedStateOnDemand<{ flag: string; label: string }[]>(
      "selectedFlag",
      [],
    );

  // Harmon
  const [selectedOptionsHarmon, setSelectedOptionsHarmon, persistHarmon] =
    usePersistedStateOnDemand<{ value: string; label: string }[]>(
      "selectedHarmon",
      [],
    );

  // STATUS
  const [selectedOptionsStatus, setSelectedOptionsStatus, persistStatus] =
    usePersistedStateOnDemand<{ status: string; label: string }[]>(
      "selectedStatus",
      [],
    );

  const [selectedOptionsCenter, setSelectedOptionsCenter, persistCenter] =
    usePersistedStateOnDemand<{ value: string; label: string }[]>(
      "selectedCenter",
      [],
    );

  const { isTax } = useRoles();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setFilter] = useState(false);
  const [ncmApiError, setNcmApiError] = useState<string | null>(null);

  const [isDownloading, setIsDownloading] = useState(false);

  const { download } = useReportDownload(setIsDownloading, setBackgroudError);
  const containerRef = useRef<HTMLDivElement>(null);
  
  const scrollToTop = () => {
    if (containerRef.current?.scrollIntoView) {
      containerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (typeof navigator !== "undefined" && /jsdom/i.test(navigator.userAgent)) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    } else if (
      globalThis.window !== undefined &&
      typeof globalThis.window.scrollTo === "function"
    ) {
      try {
        globalThis.window.scrollTo({ top: 0, behavior: "smooth" });
      } catch {
        console.error("window.scrollTo is not supported in this environment.");
      }
    }
  };

  useEffect(() => {
    if (notification) {
    scrollToTop();
    }
  }, [notification]);


  const handleDownload = useCallback(async () => {
    setBackgroudError("#DCEEFF");
    SetLabelNotification("Aguarde, o relatório está sendo exportado.");
    setNotification(true);

    const result = await download();

    if (result.success) {
      setBackgroudError("#B8EFC9");

      showNotificationUtil(
        "Relatório exportado com sucesso!",
        SetLabelNotification,
        setNotification,
      );
    } else if (result.message) {
      showNotificationUtil(
        result.message,
        SetLabelNotification,
        setNotification,
      );
    } else {
      setNotification(false);
    }
  }, [download]);

  const handleSortChange = (model: GridSortModel) => {
    setSortModel(model);
    setPage(1);
  };

  const buildTaxPayload = () => {
    return {
      status: selectedOptionsStatus.map((option) => option.status).join(","),
      flag: selectedOptionsFlag.map((option) => option.flag).join(","),
      ncmHarmonizationAlert: selectedOptionsHarmon
        .map((option) => option.value)
        .join(","),
      productCode: materialPartNumber?.toString() ?? "",
      presentationName: materialPartDesc?.toString() ?? "",
      emitter: emitentePartNumber?.toString() ?? "",
      center: selectedOptionsCenter.map((option) => option.value).join(","),
      startDate,
      endDate,
      classificationQuizStartDate,
      classificationQuizFinishDate,
      classificationApprovalStartDate,
      classificationApprovalEndDate,
      page,
      size: pageSize,
      sortBy: resolveSortByField(sortField, "classificationCreateDate"),
      sortDirection: sort,
    };
  };

  const handleFilter = async () => {
    // garante que tudo vai pro localStorage antes do dispatch
    persistStatus();
    persistFlag();
    persistCenter();
    persistHarmon();
    persistMaterialPartNumber();
    persistMaterialPartDesc();
    persistCenterFilter();
    persistEmitentePartNumber();
    persistStartDate();
    persistEndDate();
    persistClassificationQuizStartDate();
    persistClassificationQuizFinishDate();
    persistClassificationApprovalStartDate();
    persistClassificationApprovalEndDate();

    setLoading(true);
    setPage(1);

    const statusParam = selectedOptionsStatus.map((o) => o.status).join(",");
    const flagParam = selectedOptionsFlag.map((o) => o.flag).join(",");
    const flagHarmon = selectedOptionsHarmon.map((o) => o.value).join(",");
    const centerParam = selectedOptionsCenter.map((o) => o.value).join(",");

    await dispatch(
      getClassificationsTax({
        status: statusParam,
        flag: flagParam,
        ncmHarmonizationAlert: flagHarmon,
        productCode: materialPartNumber.toString(),
        presentationName: materialPartDesc.toString(),
        emitter: emitentePartNumber.toString(),
        center: centerParam,
        startDate,
        endDate,
        classificationQuizStartDate,
        classificationQuizFinishDate,
        classificationApprovalStartDate,
        classificationApprovalEndDate,
        page,
        size: pageSize,
        sortBy: resolveSortByField(sortField, "classificationCreateDate"),
        sortDirection: sort,
      }),
    ).finally(() => setLoading(false));
  };

  const sortModelGridTax = (field: string) => {
    if (!isTax) return;

    const current = sortModel.find((item) => item.field === field);
    const nextSort: GridSortDirection =
      current?.sort === "asc" ? "desc" : "asc";

    setSortModel([{ field, sort: nextSort }]);
    setPage(1);
  };

  const { sessionClassificationstax } = useSelector(
    (state: RootState) => state.sessionClassifications,
  );

  const handleApprover = async () => {
    if (!classificationId?.classificationId) {
      console.error("Classification ID is missing.");
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await dispatch(
        classificationsAprroverTax(classificationId?.classificationId),
      );

      if (response.payload.httpStatus === 422) {
        setModalApprover(false);
        setNotification(true);
        setBackgroudError("#FFD9D9");
        SetLabelNotification(
          functionDate.formatKey(Textnotifications.getAprovarError()),
        );

        setTimeout(() => {
          setNotification(false);
        }, 5000);

        return;
      }

      await dispatch(getClassificationsTax(buildTaxPayload()));

      setModalApprover(false);
      SetLabelNotification(
        Textnotifications.getAprovarSuccess(classificationId?.partNumber),
      );
      setPage(1);
      setNotification(true);
      setBackgroudError("#B8EFC9");

      setTimeout(() => {
        setNotification(false);
      }, 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCorrigir = async () => {
    if (!classificationId?.classificationId) {
      console.error("Classification ID is missing.");
      return;
    }
    setIsSubmitting(true);
    setNcmApiError(null);

    try {
      const response = await dispatch(
        getClassificationsMessage({
          classificationId: classificationId.classificationId,
          message: corrigirText,
          userRole: "TAX",
          origin: "JUSTIFICATIVA",
          ncmCode: ncmCode,
        }),
      );

      if (response.payload?.httpStatus === 422) {
        setNcmApiError(resolveNcmErrorMessage(response.payload?.message));
        setNotification(false);
      } else {
        await dispatch(getClassificationsTax(buildTaxPayload()));
        setNcmApiError(null);
        setNotification(true);
        SetLabelNotification(
          Textnotifications.getCorrigirSuccess(classificationId?.partNumber),
        );
        setBackgroudError("#B8EFC9");
        setPage(1);
        setModalCorrigir(false);
        setCorrigirText("");
        setNcmCode("");
      }
    } finally {
      setIsSubmitting(false);
      setTimeout(() => {
        setNotification(false);
      }, 5000);
    }
  };

  const handleDisableButton = (isDisabled: boolean) => {
    setIsButtonDisabled(isDisabled);
  };

  const getActionButtons = (status: string, row: any) => {

    const handleVisualizarMaterial = async () => {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1500));
      const result = await dispatch(
        getClassificationsId({ id: row.classificationId }),
      );

      if (getClassificationsId.fulfilled.match(result)) {
        localStorage.setItem("selectedEmiiter", row.emitter ?? "");
        setLoading(false);
        navigate(`/detalhes-material/${row.partNumber}?center=${row.center}`);
      } else {
        console.error("Erro ao buscar classificação", result);
      }
    };

    return [
      // Visualizar (sempre habilitado)
      <Tooltip title="Visualizar" key="visualizar">
        <div className="buttonActions">
          <ButtonGeneric
            img={EyesButtonIcon}
            style="buttonImg"
            onClick={handleVisualizarMaterial}
          />
        </div>
      </Tooltip>,
    ];
  };

  const { sort = "desc", field: sortField = "classificationCreateDate" } =
    sortModel[0] || {};
  const onOpenDescription = useCallback((desc: string) => {
    setIsModalOpen(true);
    setDescription(desc);
  }, []);

  const columns = useMemo(
    () =>
      getTaxColumns({
        sortModel,
        onOpenDescription,
        ascIcon: asc,
        descIcon: desc,
        getActionButtons,
        onTap: sortModelGridTax,
      }),
    [sortModel, onOpenDescription, asc, desc, getActionButtons],
  );

  useEffect(() => {
    if (!isTax) return;

    const filtersFromStorage = getTaxFiltersFromStorage();

    dispatch(
      getClassificationsTax({
        status: filtersFromStorage.statuses.join(","),
        flag: filtersFromStorage.flags.join(","),
        ncmHarmonizationAlert: filtersFromStorage.harmon.join(","),
        productCode: filtersFromStorage.material,
        presentationName: filtersFromStorage.description,
        emitter: filtersFromStorage.emitter,
        center: filtersFromStorage.centers.join(","),
        startDate: filtersFromStorage.startDate,
        endDate: filtersFromStorage.endDate,
        classificationQuizStartDate:
          filtersFromStorage.classificationQuizStartDate,
        classificationQuizFinishDate:
          filtersFromStorage.classificationQuizFinishDate,
        classificationApprovalStartDate:
          filtersFromStorage.classificationApprovalStartDate,
        classificationApprovalEndDate:
          filtersFromStorage.classificationApprovalEndDate,
        page,
        size: pageSize,
        sortBy: resolveSortByField(sortField, "classificationCreateDate"),
        sortDirection: sort,
      }),
    );
  }, [page, pageSize, sort, sortField]);

  useEffect(() => {
    const homeNotification = localStorage.getItem(HOME_NOTIFICATION_KEY);

    if (!homeNotification) {
      return;
    }

    try {
      const parsedNotification = JSON.parse(homeNotification);

      if (parsedNotification?.message) {
        setBackgroudError(parsedNotification.backgroundError || "#B8EFC9");
        showNotificationUtil(
          parsedNotification.message,
          SetLabelNotification,
          setNotification,
        );
      }
    } catch (error) {
      console.error("Erro ao ler notificação da home:", error);
    } finally {
      localStorage.removeItem(HOME_NOTIFICATION_KEY);
    }
  }, []);

  useEffect(() => {
    if (!isTax) return;

    if (sessionClassificationstax) {
      setRows(sessionClassificationstax?.content ?? []);
      setTotalPages(sessionClassificationstax.page?.totalPages ?? 1);
    }
  }, [sessionClassificationstax]);

  const handleReset = async () => {
    if (!classificationId?.classificationId) {
      setModalReset(false);
      console.error("Classification ID is missing.");
      return;
    }
    setIsSubmitting(true);

    try {
      const verifyResult = await dispatch(
        getSessionResetVerifyPn({
          pn: classificationId.partNumber,
          ct: classificationId.center,
        }),
      ).unwrap();
      
      const sessionId = verifyResult?.message;

      if (!sessionId) {
        setModalReset(false);
        setBackgroudError("#FFD9D9");
        showNotificationUtil(
          functionDate.formatBodyText(Textnotifications.getResetError(classificationId.partNumber,true)),
          SetLabelNotification,
          setNotification,
        );
        return;
      }

      await dispatch(getSessionReset(sessionId)).unwrap();

      const successMessage = Textnotifications.getResetSuccess(classificationId.partNumber);

      await dispatch(getClassificationsTax(buildTaxPayload()));

      setModalReset(false);
      setBackgroudError("#B8EFC9");
      showNotificationUtil(
        functionDate.formatBodyText(successMessage),
        SetLabelNotification,
        setNotification,
      );
    } catch (error: any) {
      setModalReset(false);

      const errorMessage = Textnotifications.getResetError(classificationId.partNumber);

      setBackgroudError("#FFD9D9");
      showNotificationUtil(
        functionDate.formatBodyText(errorMessage),
        SetLabelNotification,
        setNotification,
      );

      console.error("Erro ao resetar classificação:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div ref={containerRef} style={{ height: "100%" }}>
      <SkeletonWrapper loading={loading} />

      {!loading && (
        <>
          <div className="containerHomePage">
            {notification && (
              <Notification
                label={labelNotification}
                backgroundError={backgroudError}
                setNotification={setNotification}
                img={SucessIcon}
              />
            )}
            <Heading
              titlePage="Relatório de Solicitações"
              filtros="sim"
              blockText="sim"
              materialPartDesc={materialPartDesc}
              setMaterialPartDesc={setMaterialPartDesc}
              centerFilter={centerFilter}
              setCenterFilter={setCenterFilter}
              setMaterialPartNumber={setMaterialPartNumber}
              materialPartNumber={materialPartNumber}
              emitentePartNumber={emitentePartNumber}
              setEmitentePartDesc={setEmitentePartNumber}
              setStartDate={setStartDate}
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              classificationQuizStartDate={classificationQuizStartDate}
              setClassificationQuizStartDate={setClassificationQuizStartDate}
              classificationQuizFinishDate={classificationQuizFinishDate}
              setClassificationQuizFinishDate={setClassificationQuizFinishDate}
              classificationApprovalStartDate={classificationApprovalStartDate}
              setClassificationApprovalStartDate={setClassificationApprovalStartDate}
              classificationApprovalEndDate={classificationApprovalEndDate}
              setClassificationApprovalEndDate={setClassificationApprovalEndDate}
              selectedOptionsStatus={selectedOptionsStatus}
              setSelectedOptionsStatus={setSelectedOptionsStatus}
              selectedOptionsCenter={selectedOptionsCenter}
              setSelectedOptionsCenter={setSelectedOptionsCenter}
              selectedOptionsFlag={selectedOptionsFlag}
              setSelectedOptionsFlag={setSelectedOptionsFlag}
              selectedOptionsHarmon={selectedOptionsHarmon}
              setSelectedOptionsHarmon={setSelectedOptionsHarmon}
              handleFilter={handleFilter}
              setPage={setPage}
              setPageSize={setPageSize}
              setFilter={setFilter}
            />
          </div>

          <div className="containerRequest">
            <div style={{ paddingBottom: "10px" }}>
              <span className="titleRequest">Processo de Solicitações</span>
            </div>
            <div className="containerBalls">
              <BallsColor titleStatus="Novo" colorStatus="#979EA4" />
              <BallsColor
                titleStatus="Em Classificação"
                colorStatus="#9DC9FF"
              />
              <BallsColor
                titleStatus="Pendente de Validação Fiscal"
                colorStatus="#A1DFDB"
              />
              <BallsColor titleStatus="Em Análise" colorStatus="#EEC100" />
              <BallsColor titleStatus="Entregue SAP" colorStatus="#003E64" />
              <BallsColor
                titleStatus="Processo Finalizado"
                colorStatus="#00884A"
              />
              <BallsColor titleStatus="Reclassificar" colorStatus="#9E2896" />
              <BallsColor titleStatus="Reclassificado" colorStatus="#FF9D9D" />
              <BallsColor titleStatus="Suspenso" colorStatus="#E8B6E3" />
              <BallsColor titleStatus="Pendente de Grupo" colorStatus="#F97316" />
            </div>
          </div>

          <div className="genericGrid">
            <div className="exportBtn">
              <Tooltip title="Baixar relatório">
                <button
                  type="button"
                  onClick={handleDownload}
                  disabled={isDownloading}
                  aria-label="Baixar relatório"
                  className="iconButton"
                >
                  <IconDownload className="iconDownload" />
                </button>
              </Tooltip>
            </div>

            <GenericGrid
              rows={rows}
              totalPages={totalPages}
              page={page}
              columns={columns}
              setCurrentPage={setPage}
              totalElements={sessionClassificationstax?.page?.totalElements}
              setLoading={setLoading}
              sortModel={sortModel}
              handleSortChange={handleSortChange}
              setPage={setPage}
              enablePageSizeSelector={true}
              pageSize={pageSize}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setPage(1);
              }}
            />
          </div>
          {isModalOpen && (
            <ModalLog
              className="ModalViewDescriptions modalContent"
              titleModalLog={"Descrição"}
              subTitleModalLog={description || ""}
              textModalLog={""}
              imgIcon={iconabort}
              onClose={() => setIsModalOpen(false)}
            />
          )}

          {modalApprover && (
            <ModalAprover
              titleModal="Aviso"
              titleDescription={
                <div
                  className="titleAprover"
                  dangerouslySetInnerHTML={{
                    __html: functionDate.formatBodyText(
                      Textnotifications.getAprovarBodyText(),
                    ),
                  }}
                />
              }
              bodyModal={
                <div
                  className="titleAproverText"
                  dangerouslySetInnerHTML={{
                    __html: functionDate.formatBodyText(
                      Textnotifications.getAprovarBodyDescription(
                        classificationId?.partNumber,
                        classificationId?.ncmCode,
                      ),
                    ),
                  }}
                />
              }
              isSubmitting={isSubmitting}
              buttonOne="Aprovar"
              onConfirm={handleApprover}
              buttonTwo="Cancelar"
              onClose={() => setModalApprover(false)}
            />
          )}

          {modalCorrigir && (
            <CorrigirModal
              open={modalCorrigir}
              onClose={() => {
                setModalCorrigir(false);
                setCorrigirText("");
                setNcmCode("");
                setIsButtonDisabled(true);
                setNcmApiError(null);
              }}
              onConfirm={handleCorrigir}
              corrigirText={corrigirText}
              setCorrigirText={setCorrigirText}
              ncmCode={ncmCode}
              setNcmCode={setNcmCode}
              isButtonDisabled={isButtonDisabled}
              onDisableButton={handleDisableButton}
              isSubmitting={isSubmitting}
              ncmApiError={ncmApiError}
              setNcmApiError={setNcmApiError}
              mode="tax"
            />
          )}

          {modalReset && (
            <Modal
              titleDescription="Você deseja resetar a classificação?"
              titleModal="Aviso"
              bodyModal={
                <span className="resetModalBody">
                  Ao confirmar a ação, a classificação voltará para o status
                  "Novo" e o processo será reiniciado do zero.
                </span>
              }
              onClose={() => setModalReset(false)}
              onConfirm={handleReset}
              buttonOne="Resetar"
              buttonTwo="Cancelar"
              className="modalLogouts"
              isSubmitting={isSubmitting}
            />
          )}
        </>
      )}
    </div>
  );
};

export default RequestTax;
